<template>
  <e-select v-model="modelValue" :items="items" item-title="name" item-value="value" label="Страна">
    <template #selection="{ item }">
      <div class="d-flex align-center">
        <v-img :src="item.raw.flag" width="20" class="mr-2" :transition="false" />
        {{ item.title }}
      </div>
    </template>

    <template #item="{ item }">
      <div class="d-flex align-center">
        <v-img :src="item.raw.flag" width="20" class="mr-2" :transition="false" />
        {{ item.title }}
      </div>
    </template>
  </e-select>
</template>

<script setup lang="ts">
import RUFlag from '@/assets/img/common/countries/RU.svg';
import GlobalFlag from '@/assets/img/common/countries/global.svg';
import { ESelect } from '@/core/components/ui';
import { LegalOrigin } from '@/graphql/generated';

const modelValue = defineModel<LegalOrigin | null>({ required: true });

const items = [
  {
    value: LegalOrigin.Ru,
    name: 'Российская Федерация',
    flag: RUFlag,
  },
  {
    value: LegalOrigin.Other,
    name: 'Другая',
    flag: GlobalFlag,
  },
];
</script>
